import { makeAutoObservable } from 'mobx'
import { type Integration } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'
import { IntegrationTimelineStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationTimelineStore'
import { AircallNumbersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersStore'

export class IntegrationAircallSettingsStore {
  private _collapseStore
  private _timelineStore
  private _aircallNumbersStore

  constructor(integration: Integration, private _entities: IEntitiesStore) {
    this._collapseStore = new IntegrationCollapseSettingsStore()
    this._timelineStore = new IntegrationTimelineStore(this._entities, 'aircall')
    this._aircallNumbersStore = new AircallNumbersStore(this._entities)
    makeAutoObservable(this)
  }

  init = async () => {
    this._timelineStore.init()
    await this._aircallNumbersStore.init()
  }

  get collapseStore() {
    return this._collapseStore
  }

  get timelineStore() {
    return this._timelineStore
  }

  get aircallNumbersStore() {
    return this._aircallNumbersStore
  }
}
